import React from "react";
import { default as BootstrapModal } from "react-bootstrap/Modal";
import { useStore } from "../../store/store";
import PlayObjectModal from "./PlayObjectModal/PlayObjectModal";
import PlayObjectModal2 from "./PlayObjectModal2/PlayObjectModal2";
import ObjectsTableModalContent from "./ObjectsTableModalContent/ObjectsTableModalContent";
import ObjectsTableModalContent2 from "./ObjectsTableModalContent2/ObjectsTableModalContent2";
import AutoUiModal from "./AutoUiModal/AutoUiModal";
import QuillModal from "./QuillModal/QuillModal";
import TextEditorModal from "./TextEditorModal/TextEditorModal";
import LinkEditorModal from "./LinkEditorModal/LinkEditorModal";
import SubObjectModal from "./SubObjectModal/SubObjectModal";
import DeepImageModal from "./DeepImageModal/DeepImageModal";
import DeepAudioModal from "./DeepAudioModal/DeepAudioModal";
import DeepVideoModal from "./DeepVideoModal/DeepVideoModal";
import PlayCompositeBlocks from "./PlayCompositeBlocks/PlayCompositeBlocks";
import EditCompositeBlocks from "./EditCompositeBlocks/EditCompositeBlocks";
import GlossaryModal from "./GlossaryModal/GlossaryModal";
import CompositeBlocksModal from "./CompositeBlocksModal/CompositeBlocksModal";
import EnrichingContentModal from "./EnrichingContentModal/EnrichingContentModal";
import VirtualBlockContentModal from "./VirtualBlockContentModal/VirtualBlockContentModal";
import VirtualBlockReaderModal from "./VirtualBlockReaderModal/VirtualBlockReaderModal";
import VirtualBlockReaderNavigationModal from "./VirtualBlockReaderNavigationModal/VirtualBlockReaderNavigationModal";
import IframeDisplayModal from "./IframeDisplayModal/IframeDisplayModal";
import VideoPlayerModal from "./VideoPlayerModal/VideoPlayerModal";
import AudioPlayerModal from "./AudioPlayerModal/AudioPlayerModal";
import SelectFromLibraryModal from "./SelectFromLibraryModal/SelectFromLibraryModal";
import ImportPagesModal from "./ImportPagesModal";
import AddChapterModal from "./AddChapterModal/AddChapterModal";

// Modal registry
const MODAL_COMPONENTS = {
  "play-object": PlayObjectModal,
  "play-object-2": PlayObjectModal2,
  tabs: ObjectsTableModalContent,
  "virtual-blocks": ObjectsTableModalContent2,
  "virtual-block-content": VirtualBlockContentModal,
  "virtual-block-reader": VirtualBlockReaderModal,
  "virtual-block-reader-nav": VirtualBlockReaderNavigationModal,
  "iframe-display": IframeDisplayModal,
  "video-player": VideoPlayerModal,
  "audio-player": AudioPlayerModal,
  "auto-ui": AutoUiModal,
  quill: QuillModal,
  "text-editor": TextEditorModal,
  "link-editor": LinkEditorModal,
  "sub-object": SubObjectModal,
  "deep-image": DeepImageModal,
  "deep-audio": DeepAudioModal,
  "deep-video": DeepVideoModal,
  "play-composite-blocks": PlayCompositeBlocks,
  "edit-composite-blocks": EditCompositeBlocks,
  glossary: GlossaryModal,
  "composite-blocks-modal": CompositeBlocksModal,
  "enriching-content": EnrichingContentModal,
  "select-from-library": SelectFromLibraryModal,
  "import-pages": ImportPagesModal,
};

const Modal = () => {
  const { modal, closeModal } = useStore();

  const { name = "", size = "xl", opened = false, props = {} } = modal;

  if (name === "import-pages") {
    return (
      <ImportPagesModal open={opened} handleCloseModal={closeModal} {...props} />
    );
  }

  if (name === "add-chapter") {
    return (
      <AddChapterModal open={opened} handleCloseModal={closeModal} {...props} />
    );
  }

  // Get modal component by name
  const ModalComponent = MODAL_COMPONENTS[name] || null;

  return (
    <BootstrapModal show={opened} onHide={closeModal} size={size}>
      {ModalComponent && (
        <ModalComponent {...props} handleCloseModal={closeModal} />
      )}
    </BootstrapModal>
  );
};

export default Modal;
